
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LinkPagamentoAdminResponse {
  reservaId: number;
  asaasPaymentId: string;
  invoiceUrl: string;
  status: string;
  expiraEm: string;
}

@Injectable({
  providedIn: 'root'
})
export class AdminReservaService {

  private readonly api =
    `${environment.apiUrl}/admin/reservas`;

  constructor(private http: HttpClient) {}

  gerarLinkPagamento(
    reservaId: number
  ): Observable<LinkPagamentoAdminResponse> {

    return this.http.post<LinkPagamentoAdminResponse>(
      `${this.api}/${reservaId}/link-pagamento`,
      {}
    );
  }
}
